enum TaskTypes {
    SET_SELECTED_TASK = 'SET_SELECTED_TASK',
    CLEAR_UNREAD = 'CLEAR_UNREAD',
    ADD_TASK_CONNECTION = 'ADD_TASK_CONNECTION',
    END_TASK = 'END_TASK',
    REMOVE_TASK_CONNECTION = 'REMOVE_TASK_CONNECTION',
    CLEAR_TASK_CONNECTION = 'CLEAR_TASK_CONNECTION',
    TASK_CONNECTED = 'TASK_CONNECCTED',
    TASK_DISCONNECTED = 'TASK_DISCONNECTED',
    TASK_ACW = 'TASK_ACW',
    TASK_MISSED = 'TASK_MISSED',
    ACCEPT_TASK = 'ACCEPT_TASK',
    DECLINE_TASK = 'DECLINE_TASK',
    COMPLETE_TASK_ACW = 'COMPLETE_TASK_ACW',
    RECOVER_TASKS = 'RECOVER_TASKS',
    TRANSFER_TASK = 'TRANSFER_TASK',
    SET_TASK_REPLY_TEXT = 'SET_TASK_REPLY_TEXT',
    CLEAR_TASK_REPLY_TEXT = 'CLEAR_TASK_REPLY_TEXT',
    UPDATE_CONNECTION_EDITOR_CONTENT = 'UPDATE_CONNECTION_EDITOR_CONTENT',
    SEND_TASK_ATTACHMENT = 'SEND_TASK_ATTACHMENT',
    SET_TASK_ATTACHMENT = 'SET_TASK_ATTACHMENT',
    DELETE_TASK_ATTACHMENT = 'DELETE_TASK_ATTACHMENT',
    SET_INCLUDE_CC_IN_REPLY = 'SET_INCLUDE_CC_IN_REPLY',
}

export default TaskTypes;
